import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import useCurrentEvents from "../../hooks/useCurrentEvents";

const WeatherComponent = ({ icon }) => {
  const { farmingEvent } = useCurrentEvents();
  if (icon === "heavyRain") {
    return (
      <div className="panel weather-component">
        <span>Weather</span>
        <StaticImage
          src="../../../static/assets/images/weather-icons/weather-heavyRain.png"
          alt="Heavy Rain"
          layout="fixed"
          width={80}
          height={80}
          placeholder="none"
        />
        <hr />
        <span>Heavy Rain</span>
      </div>
    );
  }
  if (icon === "highWind") {
    return (
      <div className="panel weather-component">
        <span>Weather</span>
        <StaticImage
          src="../../../static/assets/images/weather-icons/weather-highWind.png"
          alt="High Wind"
          layout="fixed"
          width={80}
          height={80}
          placeholder="none"
        />
        <hr />
        <span>High Wind</span>
      </div>
    );
  }
  if (icon === "lightDrizzle") {
    return (
      <div className="panel weather-component">
        <span>Weather</span>
        <StaticImage
          src="../../../static/assets/images/weather-icons/weather-lightDrizzle.png"
          alt="Light Drizzle"
          layout="fixed"
          width={80}
          height={80}
          placeholder="none"
        />
        <hr />
        <span>Light Drizzle</span>
      </div>
    );
  }
  if (icon === "newCrop") {
    return (
      <div className="panel weather-component">
        <span>Weather</span>
        <StaticImage
          src="../../../static/assets/images/weather-icons/weather-newCrop.png"
          alt="New Crop"
          layout="fixed"
          width={80}
          height={80}
          placeholder="none"
        />
        <hr />
        <span>New Crop Planted</span>
      </div>
    );
  }
  if (icon === "storm") {
    return (
      <div className="panel weather-component">
        <span>Weather</span>
        <StaticImage
          src="../../../static/assets/images/weather-icons/weather-storm.png"
          alt="Storm"
          layout="fixed"
          width={80}
          height={80}
          placeholder="none"
        />
        <hr />
        <span>Storm Damage</span>
      </div>
    );
  }
  if (icon === "sun") {
    return (
      <div className="panel weather-component">
        <span>Weather</span>
        <StaticImage
          src="../../../static/assets/images/weather-icons/weather-sun.png"
          alt="High Sun"
          layout="fixed"
          width={80}
          height={80}
          placeholder="none"
        />
        <hr />
        <span>High Sun</span>
      </div>
    );
  }

  if (icon === "insects") {
    return (
      <div className="panel weather-component">
        <span>Pests</span>
        <StaticImage
          src="../../../static/assets/images/weather-icons/weather-insects.png"
          alt="Insects"
          layout="fixed"
          width={80}
          height={80}
          placeholder="none"
        />
        <hr />
        <span>Crop Failure</span>
      </div>
    );
  }
  if (icon === "pests") {
    return (
      <div className="panel weather-component">
        <span>Pests</span>
        <StaticImage
          src="../../../static/assets/images/weather-icons/weather-pests.png"
          alt="Pests"
          layout="fixed"
          width={80}
          height={80}
          placeholder="none"
        />
        <hr />
        <span>Crop Damage</span>
      </div>
    );
  }

  if (icon === "newCrop") {
    return (
      <div className="panel weather-component">
        <span>Event</span>
        <StaticImage
          src="../../../static/assets/images/weather-icons/weather-newCrop.png"
          alt="New Crop"
          layout="fixed"
          width={80}
          height={80}
          placeholder="none"
        />
        <hr />
        <span>New Crop Planted</span>
      </div>
    );
  }

  if (icon === "event" && farmingEvent) {
    if (farmingEvent.visuals == "halloween") {
      return (
        <div className="panel weather-component">
          <span>Event</span>
          <StaticImage
            src="../../../static/assets/images/weather-icons/event-halloween.png"
            alt="Zombie attack"
            layout="fixed"
            width={80}
            height={80}
            placeholder="none"
          />
          <hr />
          <span>Zombie attack</span>
        </div>
      );
    }
  }

  return (
    <div className="panel weather-component">
      <span>Event</span>
      <StaticImage
        src="../../../static/assets/images/weather-icons/weather-none.png"
        alt="None"
        layout="fixed"
        width={80}
        height={80}
        placeholder="none"
      />
      <hr />
      <span>None</span>
    </div>
  );
};

export default WeatherComponent;
